<template>
  <div>
    <b-loading :is-full-page="true" :active="!initialized"></b-loading>
    <section v-if="initialized" class="section is-main-section">
      <CardComponent>
        <div class="section has-text-centered">
          <h1 class="title">
            {{ added ? 'Create New Channel' : 'Edit Channel' }}
          </h1>
        </div>
        <div class="columns is-vcentered">
          <div class="column is-8 is-offset-2">
            <div class="flex-card light-bordered light-raised">
              <div class="card-body">
                <ValidationObserver ref="observer" v-slot="{ passes, errors }">
                  <form @submit.prevent="passes(submit)">
                    <div class="columns is-multiline">
                      <div class="column is-6">
                        <div class="control">
                          <ValidationProvider
                            v-slot="{ errors }"
                            name="Name"
                            rules="required"
                          >
                            <b-field
                              label="Name"
                              :type="{ 'is-danger': errors.length > 0 }"
                              :message="errors[0]"
                            >
                              <b-input v-model="item.name" />
                            </b-field>
                          </ValidationProvider>
                        </div>
                      </div>
                      <div class="column is-6">
                        <div class="control">
                          <BaseTimePicker
                            label="Channel Start Time"
                            :increment-minutes="15"
                            v-model="item.start_time"
                            rules="required"
                          />
                        </div>
                      </div>
                      <div class="column is-12">
                        <div class="control">
                          <b-field class="has-margin-top-10">
                            <b-checkbox v-model="item.commercials_limit"
                              >Limit Commercial Time Range?</b-checkbox
                            >
                          </b-field>
                        </div>
                      </div>
                      <div class="column is-6" v-if="item.commercials_limit">
                        <div class="control">
                          <BaseTimePicker
                            label="Commercials Start Time"
                            :increment-minutes="15"
                            v-model="item.commercials_start_time"
                            rules="required"
                          />
                        </div>
                      </div>
                      <div class="column is-6" v-if="item.commercials_limit">
                        <div class="control">
                          <BaseTimePicker
                            label="Commercials End Time"
                            :increment-minutes="15"
                            v-model="item.commercials_end_time"
                            rules="required"
                          />
                        </div>
                      </div>
                      <div class="column is-12">
                        <p class="is-size-4">
                          <strong>30 Minute Configuration</strong>
                        </p>
                        <draggable
                          v-model="minutes30_segments_config"
                          class="columns is-multiline"
                        >
                          <template
                            v-for="(config, index) of minutes30_segments_config"
                          >
                            <div class="column is-2" :key="index">
                              <div class="control relative">
                                <BaseInput
                                  rules="required"
                                  :label="`Segment duration`"
                                  type="number"
                                  v-if="
                                    config.segment &&
                                    index !==
                                      minutes30_segments_config.length - 1
                                  "
                                  v-model="config.segment"
                                />
                                <BaseInput
                                  rules="required"
                                  :label="`Commercial duration`"
                                  type="number"
                                  v-if="
                                    config.commercial &&
                                    index !==
                                      minutes30_segments_config.length - 1
                                  "
                                  v-model="config.commercial"
                                />
                                <b-field
                                  v-if="
                                    index ===
                                    minutes30_segments_config.length - 1
                                  "
                                  :label="
                                    config.segment
                                      ? 'Segment Duration'
                                      : 'Commercial Duration'
                                  "
                                >
                                  <span>Auto</span>
                                </b-field>
                                <a
                                  href=""
                                  @click.prevent="remove30minuteItem(index)"
                                  style="
                                    position: absolute;
                                    top: 0px;
                                    right: 0px;
                                  "
                                  ><b-icon icon="close"
                                /></a>
                              </div>
                            </div>
                          </template>
                        </draggable>
                        <div class="has-margin-top-15 has-margin-left-15">
                          <b-button @click="add30MinSegment('segment')"
                            >Add Segment</b-button
                          >
                          <b-button
                            class="has-margin-left-10"
                            @click="add30MinSegment('commercial')"
                            >Add Commercial</b-button
                          >
                        </div>
                      </div>

                      <div class="column is-12">
                        <p class="is-size-4">
                          <strong>60 Minute Configuration</strong>
                        </p>
                        <draggable
                          v-model="minutes60_segments_config"
                          class="columns is-multiline"
                        >
                          <template
                            v-for="(config, index) of minutes60_segments_config"
                          >
                            <div class="column is-2" :key="index">
                              <div class="control relative">
                                <BaseInput
                                  rules="required"
                                  :label="`Segment duration`"
                                  type="number"
                                  v-if="
                                    config.segment &&
                                    index !==
                                      minutes60_segments_config.length - 1
                                  "
                                  v-model="config.segment"
                                />
                                <BaseInput
                                  rules="required"
                                  :label="`Commercial duration`"
                                  type="number"
                                  v-if="
                                    config.commercial &&
                                    index !==
                                      minutes60_segments_config.length - 1
                                  "
                                  v-model="config.commercial"
                                />
                                <b-field
                                  v-if="
                                    index ===
                                    minutes60_segments_config.length - 1
                                  "
                                  :label="
                                    config.segment
                                      ? 'Segment Duration'
                                      : 'Commercial Duration'
                                  "
                                >
                                  <span>Auto</span>
                                </b-field>
                                <a
                                  href=""
                                  @click.prevent="remove60minuteItem(index)"
                                  style="
                                    position: absolute;
                                    top: 0px;
                                    right: 0px;
                                  "
                                  ><b-icon icon="close"
                                /></a>
                              </div>
                            </div>
                          </template>
                        </draggable>
                        <div class="has-margin-top-15 has-margin-left-15">
                          <b-button @click="add60MinSegment('segment')"
                            >Add Segment</b-button
                          >
                          <b-button
                            class="has-margin-left-10"
                            @click="add60MinSegment('commercial')"
                            >Add Commercial</b-button
                          >
                        </div>
                      </div>
                    </div>
                    <div class="has-text-centered">
                      <div class="is-block has-margin-bottom-15">
                        <b-button
                          icon-left="arrow-left"
                          class="is-medium has-margin-right-10"
                          tag="router-link"
                          :to="{
                            name: 'ManageChannels',
                          }"
                        >
                          Back to List</b-button
                        >
                        <button
                          class="button is-primary is-medium btn-align no-lh raised primary-btn"
                          type="submit"
                          :disabled="loading"
                          :class="{ 'is-loading': loading }"
                        >
                          {{ added ? 'Create' : 'Update' }}
                        </button>
                      </div>
                    </div>
                  </form>
                </ValidationObserver>
              </div>
            </div>
          </div>
        </div>
      </CardComponent>
    </section>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import draggable from 'vuedraggable'
import CardComponent from '@/components/CardComponent'
import BaseTimePicker from '@/components/BaseTimePicker'
import BaseSelect from '@/components/BaseSelect'
import ChannelApi from '@/api/channels'

export default {
  name: 'EditChannel',
  components: {
    CardComponent,
    BaseTimePicker,
    draggable,
    BaseSelect,
  },
  metaInfo: {
    title: 'Edit Channel',
  },
  computed: {
    ...mapGetters(['user']),
  },
  async mounted() {
    this.added = this.$route.name === 'CreateChannel' ? true : false
    if (!this.added) {
      await this.setData()
    }
    this.initialized = true
  },
  data() {
    return {
      loading: false,
      initialized: false,
      added: false,
      minutes30_segments_config: [],
      minutes60_segments_config: [],
      item: {
        commercials_start_time: new Date(),
        commercials_end_time: new Date(),
      },
    }
  },
  methods: {
    ...mapActions(['getUser']),
    remove30minuteItem(index) {
      this.minutes30_segments_config.splice(index, 1)
    },
    add30MinSegment(type) {
      if (type === 'segment') {
        this.minutes30_segments_config.push({ segment: '0' })
      } else {
        this.minutes30_segments_config.push({ commercial: '0' })
      }
    },
    remove60minuteItem(index) {
      this.minutes60_segments_config.splice(index, 1)
    },
    add60MinSegment(type) {
      if (type === 'segment') {
        this.minutes60_segments_config.push({ segment: '0' })
      } else {
        this.minutes60_segments_config.push({ commercial: '0' })
      }
    },
    async setData(id) {
      this.initialized = false
      this.added = false
      let item = await ChannelApi.getById(id || this.$route.params.id)
      if (item) {
        this.item.id = item.id
        this.item.name = item.name
        this.item.start_time = new Date(item.start_time)
        this.item.commercials_start_time = item.commercials_start_time
          ? new Date(item.commercials_start_time)
          : null
        this.item.commercials_end_time = item.commercials_end_time
          ? new Date(item.commercials_end_time)
          : null
        if (item.minutes30_segments_config) {
          this.minutes30_segments_config = JSON.parse(
            item.minutes30_segments_config
          )
        }
        if (item.minutes60_segments_config) {
          this.minutes60_segments_config = JSON.parse(
            item.minutes60_segments_config
          )
        }
      }
      this.initialized = true
    },
    async submit() {
      this.loading = true
      this.item.minutes30_segments_config = this.minutes30_segments_config
      this.item.minutes60_segments_config = this.minutes60_segments_config
      if (!this.item.id) {
        try {
          let response = await ChannelApi.create(this.item)
          this.$buefy.toast.open({
            message: 'Channel created successfully!',
            position: 'is-top',
            type: 'is-success',
          })
          this.$router.push({
            name: 'EditChannel',
            params: { id: response.channelId },
          })
          await this.setData(response.channelId)
          this.loading = false
        } catch (err) {
          console.log(err)
          this.$buefy.toast.open({
            message: 'Error saving channel',
            position: 'is-top',
            type: 'is-danger',
          })
          this.loading = false
        }
      } else {
        try {
          this.item.channelId = this.item.id
          await ChannelApi.update(this.item)
          this.$buefy.toast.open({
            message: 'Channel updated successfully!',
            position: 'is-top',
            type: 'is-success',
          })
          await this.setData()
          this.loading = false
        } catch (err) {
          console.log(err)
          this.$buefy.toast.open({
            message: 'Error saving channel',
            position: 'is-top',
            type: 'is-danger',
          })
          this.loading = false
        }
      }
    },
  },
}
</script>
